var map = {
	"./decidim/coesione-logo.png": 83095,
	"./decidim/comune-ap-logo.png": 86231,
	"./decidim/default-avatar.svg": 71906,
	"./decidim/dfp-logo.png": 34100,
	"./decidim/eu-logo.png": 88830,
	"./decidim/eu-logo_bk.png": 33286,
	"./decidim/italia-domani-logo.png": 89737,
	"./decidim/medium_logo_nuova_proposta_white.png": 88240,
	"./decidim/mit-logo.png": 94224,
	"./decidim/poc-logo.png": 36052,
	"./decidim/pon-logo.png": 1327,
	"./decidim/spid/idp-logos/spid-idp-etnaid.svg": 63351,
	"./decidim/spid/idp-logos/spid-idp-infocamereid.svg": 62290,
	"./decidim/spid/idp-logos/spid-idp-teamsystemid.svg": 45723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;